/**
 * Hostname-aware /privacy and /terms routing.
 *
 * On the HustlePlate marketing site (hustleplate.au or the standalone
 * static bundle) these render the HustlePlate Pty Ltd legal pages.
 *
 * On every tenant domain they render the tenant's CMS page (so each
 * restaurant gets their own customisable Privacy/Terms via the admin
 * Pages section).
 */
import SiteLayout from "@/components/SiteLayout";
import CMSPage from "@/pages/CMSPage";
import { PrivacyPage, TermsPage } from "@/pages/sales/LegalPages";

const MARKETING_HOSTS = new Set([
  "hustleplate.au",
  "www.hustleplate.au",
]);

const STANDALONE_SALES = process.env.REACT_APP_STANDALONE_SALES === "1";

function isMarketingHost() {
  if (STANDALONE_SALES) return true;
  if (typeof window === "undefined") return false;
  const host = (window.location.hostname || "").toLowerCase();
  return MARKETING_HOSTS.has(host);
}

export function PrivacyRoute() {
  if (isMarketingHost()) return <PrivacyPage />;
  return (
    <SiteLayout>
      <CMSPage slug="privacy" />
    </SiteLayout>
  );
}

export function TermsRoute() {
  if (isMarketingHost()) return <TermsPage />;
  return (
    <SiteLayout>
      <CMSPage slug="terms" />
    </SiteLayout>
  );
}
